import type { ScopedThreadRef } from "@cmmd-forge/contracts";

import type { SidebarThreadSummary } from "~/types";

export type ThreadShelfAction = (
  threadRef: ScopedThreadRef,
  threadSnapshot?: SidebarThreadSummary,
  options?: { readonly force?: boolean },
) => Promise<void>;

export function workerCount(thread: SidebarThreadSummary, workerCount: number | undefined): number {
  return thread.kind === "master" ? (workerCount ?? 0) : 0;
}

export function archiveAction(thread: SidebarThreadSummary, isThreadRunning: boolean) {
  const archiveState = thread.archive?.state ?? null;
  return {
    archiveLabel: archiveState === "failed" ? "Retry" : "Archive",
    canArchive:
      !isThreadRunning &&
      thread.archivedAt === null &&
      (archiveState === null || archiveState === "failed"),
  };
}
